<script>
	import { Route, Router } from "svelte-routing";
    import Header from "./components/navigation/Header.svelte";
	import Menu from "./components/navigation/Menu.svelte";
	import MenuContent from "./components/navigation/MenuContent.svelte";
	import Home from "./routes/Home.svelte";
	import Impressum from "./routes/Impressum.svelte";
	import Datenschutz from "./routes/Datenschutz.svelte";
	import About from "./routes/About.svelte";
	import Orte from "./routes/Orte.svelte";
	import Ort from "./routes/Ort.svelte";
	import Personen from "./routes/Personen.svelte";
	import Person from "./routes/Person.svelte";
	
	// import QRGeneration from "./routes/QRGeneration.svelte";
	// import Testing from "./routes/Testing.svelte";

	// ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
	// Menu State Management
	// ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
	let showMenu = false;
	let showScanner = false;

	function closeMenu () {
		showMenu = false;
	}

	function closeScanner () {
		showScanner = false;
	}

	function openMenu () {
		showMenu = true;
	}

	function toggleMenu () {
		showMenu = !showMenu;
	}

	function toggleScanner () {
		showScanner = !showScanner;
	}
</script>

<Router basepath="/">
	<div class="wrapper">
		<div class="content-area">
			<Header on:toggleMenu={toggleMenu} bind:showMenu on:toggleScanner={toggleScanner} bind:showScanner/>
			<Menu on:closeMenu={closeMenu} bind:active={showMenu}>
				<div slot="content">
					<MenuContent on:closeMenu={closeMenu} on:closeScanner={closeScanner}/>
				</div>
			</Menu>
			<main>
				<Route component={Home} path="/"/>
				<Route component={Impressum} path="/impressum"/>
				<Route component={Datenschutz} path="/datenschutz"/>
				<Route component={Orte} path="/orte"/>
				<Route component={Personen} path="/personen"/>
				<Route component={About} path="/about"/>
				<Route path="/personen/:id" let:params>
					<Person id={params.id}/>
				</Route>
				<Route path="/orte/:id" let:params>
					<Ort id={params.id}/>
				</Route>

				<!-- Temporary -->
				<!-- <Route component={Testing} path="/testing"/>
				<Route component={QRGeneration} path="/qr"/> -->
			</main>
		</div>
	</div>
</Router>

<style>
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
	}

	.sidebar {
		flex-shrink: 0;
	}

	.content-area {
		/* flex-grow: 1;
		display: flex;
		flex-direction: column; */
		min-height: 100%;
		width: 100%;
	}

	main {
		flex-grow: 1;
		padding: 2rem;
		padding-top: 5.5rem;
        flex-grow: 1;
		width: 100vw;
		max-width: 40rem;
		margin: auto;
		overflow-y: auto;
		overflow-x: hidden;
	}

</style>
